import React from "react";

import { Text, StyleSheet, View, Platform } from "react-native";

import AppTheme from "../AppTheme";
import ManaButton from "./ManaButton";

export default function ItemNotFound({ name, create, type, hasResults }) {
  return (
    <View style={styles.container}>
      <Text style={styles.header}>Add {type}</Text>
      {!hasResults ? (
        <Text style={styles.info}>
          No {type} called "{name}"
        </Text>
      ) : null}

      <ManaButton
        isMainButton
        text={`Create & add "${name}"`}
        onPress={create}
        style={styles.saveButton}
        textStyle={styles.bottomButtonText}
      />
    </View>
  );
}

const styles = StyleSheet.create({
  container: {},
  header: {
    fontFamily: Platform.select({
      default: "Montserrat",
      android: "Montserrat-SemiBold",
    }),
    fontWeight: "600",
    fontSize: 16,
    lineHeight: 20,
    letterSpacing: 1,
    color: AppTheme.almostBlack,

    paddingLeft: 14,
    paddingTop: 10,
    marginBottom: 4,
    display: "flex",
    alignItems: "center",
  },
  info: {
    color: AppTheme.DEFAULT_COLOR,
    fontWeight: "bold",
    fontStyle: "italic",
    textAlign: "center",
    paddingBottom: 16,
  },
  saveButton: {
    width: "auto",
    marginHorizontal: 30,
    minWidth: 204,
    height: 40,
    paddingHorizontal: 15,
    marginBottom: 10,
    borderRadius: 25,
  },
  bottomButtonText: {
    fontSize: 16,
    lineHeight: 19,
    letterSpacing: 0.2,
    textAlign: "center",
  },
});
